import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useParams } from "react-router-dom";
import Navbar from './components/Navbar';
import { getWebClient } from '../helpers/Helpers.js';

export default function DateOreDettagli() {

    // Costanti

    const { id } = useParams();
    const client = getWebClient();
    const navigate = useNavigate();

    const [labels, setLabels] = useState();
    const [model, setModel] = useState({ id: uuidv4(), nome: '' });
    const [deleteButton, setDeleteButton] = useState('');

    const [dateField, setDateField] = useState([]);

    // Chiamate webAPI

    function dataOraGetPromise() {
        return new Promise((resolve) => {
            client.get(`/api/dateore/${id}`).then((response) => {
                resolve(response.data);
            });
        });
    }

    function dateGetPromise() {
        return new Promise((resolve) => {
            client.get(`/api/date`).then((response) => {
                resolve(response.data);
            });
        });
    }

    // Inizializzazione

    useEffect(() => {

        if (id === 'new') {

            setLabels({
                "title": "Creazione nuova data/ora",
                "submitButtonText": "Crea la data/ora",
            });

            Promise.all([dateGetPromise()])

                .then((results) => {

                    let dateGetPromiseResult = results[0];

                    setModel({
                        id: uuidv4(),
                        idData: dateGetPromiseResult[0].id,
                        progressivo: '',
                        oraDa: 'hh:mm',
                        oraA: 'hh:mm'
                    });

                    setDateField(
                        <Field name="idData" id="idData" as="select" className="form-select">
                            {dateGetPromiseResult.map((item, index) =>
                                <option key={index} value={item.id}>{item.dataTestuale}</option>
                            )}
                        </Field>
                    );

                })

                .catch((err) => {
                    console.log(err);
                });


        } else {

            setLabels({
                "title": "Dettagli della data/ora",
                "submitButtonText": "Modifica la data/ora",
            });

            setDeleteButton(<button type="button" className="btn btn-primary" style={{ marginTop: 40, marginLeft: 10 }} onClick={handleDeleteStep1}>Elimina la data</button>);

            Promise.all([dataOraGetPromise(), dateGetPromise()])

                .then((results) => {

                    let dataOraGetPromiseResult = results[0];
                    let dateGetPromiseResult = results[1];

                    setModel(dataOraGetPromiseResult);

                    setDateField(
                        <Field name="idData" id="idData" as="select" className="form-select">
                            {dateGetPromiseResult.map((item, index) =>
                                <option key={index} value={item.id}>{item.dataTestuale}</option>
                            )}
                        </Field>
                    );

                })

                .catch((err) => {
                    console.log(err);
                });

        }

    }, []);

    // Delete

    const handleDeleteStep1 = (event) => {

        setDeleteButton(
            <div className="btn-group" role="group" style={{ marginTop: 40, marginLeft: 10 }}>
                <button type="button" className="btn btn-primary" onClick={handleDeleteUndo}>Annulla</button>
                <button type="button" className="btn btn-danger" onClick={handleDeleteStep2}>Procedi con l'eliminazione</button>
            </div>
        );

    }

    const handleDeleteStep2 = (event) => {

        client.delete(`/api/dateore/${id}`)
            .then(function (response) {
                navigate("/dateore");
            })
            .catch(function (error) {
                alert("Si sono verificati errori durante l'operazione di eliminazione. Riprovare in un secondo momento.");
            });

    }

    const handleDeleteUndo = (event) => {

        setDeleteButton(<button type="button" className="btn btn-primary" style={{ marginTop: 40, marginLeft: 10 }} onClick={handleDeleteStep1}>Elimina la data</button>);

    }

    if (labels === undefined || model === undefined) { return; }

    return (
        <>

            <Navbar />

            <div className="container" style={{ marginTop: 40, marginBottom: 40 }} >
                <h4>{labels.title}</h4>
            </div>

            <div className="container" style={{ marginBottom: 80 }}>

                <Formik

                    initialValues={model}
                    enableReinitialize="true"

                    validate={values => {

                        const errors = {};

                        document.getElementById('progressivo').classList.remove("is-invalid")
                        document.getElementById('oraDa').classList.remove("is-invalid")
                        document.getElementById('oraA').classList.remove("is-invalid")

                        if (!values.progressivo) {
                            errors.progressivo = <>Il campo Progressivo &egrave; richiesto</>;
                            document.getElementById('progressivo').classList.add("is-invalid")
                        }

                        if (!values.oraDa) {
                            errors.oraDa = <>Il campo Ora da &egrave; richiesto</>;
                            document.getElementById('oraDa').classList.add("is-invalid")
                        }

                        if (!values.oraA) {
                            errors.oraA = <>Il campo Ora a &egrave; richiesto</>;
                            document.getElementById('oraA').classList.add("is-invalid")
                        }

                        return errors;
                    }}

                    onSubmit={(values, { setSubmitting }) => {

                        if (id === 'new') {

                            client.post('/api/dateore', values)
                                .then(function (response) {
                                    navigate("/dateore");
                                    setSubmitting(false);
                                })
                                .catch(function (error) {
                                    alert("Si sono verificati errori durante l'operazione di inserimento. Verificare i dati introdotti e riprovare.");
                                    setSubmitting(false);
                                });

                        } else {

                            client.put('/api/dateore', values)
                                .then(function (response) {
                                    navigate("/dateore");
                                    setSubmitting(false);
                                })
                                .catch(function (error) {
                                    alert("Si sono verificati errori durante l'operazione di inserimento. Verificare i dati introdotti e riprovare.");
                                    setSubmitting(false);
                                });

                        }
                    }}
                >

                    {({ isSubmitting }) => (

                        <Form>

                            <div className="row mb-3">
                                <label htmlFor="id" className="col-sm-2 col-form-label">Id</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="id" readOnly="readonly" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Data</label>
                                <div className="col-sm-10">
                                    {dateField}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="id" className="col-sm-2 col-form-label">Progressivo</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="number" name="progressivo" id="progressivo" />
                                    <ErrorMessage className="invalid-feedback" name="progressivo" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="id" className="col-sm-2 col-form-label">Ora inizio</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="oraDa" id="oraDa" />
                                    <ErrorMessage className="invalid-feedback" name="oraDa" component="div" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="id" className="col-sm-2 col-form-label">Ora fine</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="oraA" id="oraA" />
                                    <ErrorMessage className="invalid-feedback" name="oraA" component="div" />
                                </div>
                            </div>

                            <button className="btn btn-primary" style={{ marginTop: 40 }} type="submit" disabled={isSubmitting}>{labels.submitButtonText}</button>
                            {deleteButton}

                        </Form>

                    )}

                </Formik>


            </div>

        </>
    )
}
